<template>
  <div class="merp-page">
    <section class="banner-section">
      <div class="container">
        <div class="row">
          <div class="col-sm pt-5">
            <div class="pt-5">
              <h1>mERP</h1>
              <p>Monitor your sales, profit, expenses, inventory and employees from multiple stores in one business location.</p>
              <router-link to="/contact" class="btn btn-outline-secondary">Schedule a Demo</router-link>
              <!-- <a href="https://merp.codehit.net" target="_blank" class="btn btn-outline-secondary ml-3">View App</a> -->
            </div>
          </div>
          <div class="col-sm-6">
            <div class="pt-5">
              <a href="/img/merp.png" data-fancybox="merp-images">
                <div class="merp-banner">
                  <img src="/img/merp.png" alt="actMonit" class="img-fluid">
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="container">
      <section>
        <h3 class="mt-5">Features</h3>
        <p>Managing multiple stores in one business location ie. a bakeshop, coffeshop, restaurant and a convenience store with a common warehouse is now made simple with mERP</p>
        <div class="row">
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/merp/1.png" data-fancybox="merp-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/merp/1.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
            <a href="/img/merp/1.png" data-fancybox="merp-images">
              <h3 class="h5 mb-1">Inventory</h3>
            </a>
            <p class="text-muted">Manage your product stocks, vendors, brands, purchase and selling prices.</p>
          </div>
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/merp/2.png" data-fancybox="merp-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/merp/2.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
            <a href="/img/merp/2.png" data-fancybox="merp-images">
              <h3 class="h5 mb-1">Accounting</h3>
            </a>
            <p class="text-muted">Manage your expenses, purchasing, collections and bank deposits.</p>
          </div>
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/merp/3.png" data-fancybox="merp-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/merp/3.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
            <a href="/img/merp/3.png" data-fancybox="merp-images">
              <h3 class="h5 mb-1">Attendance</h3>
            </a>
            <p class="text-muted">Monitor your employees daily attendance, leaves and absents.</p>
          </div>
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/merp/4.png" data-fancybox="merp-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/merp/4.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
            <a href="/img/merp/4.png" data-fancybox="merp-images">
              <h3 class="h5 mb-1">Department Inventory</h3>
            </a>
            <p class="text-muted">Monitor your product stocks, sold, consumed items per department.</p>
          </div>
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/merp/5.png" data-fancybox="merp-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/merp/5.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
            <a href="/img/merp/5.png" data-fancybox="merp-images">
              <h3 class="h5 mb-1">Department Dashboard</h3>
            </a>
            <p class="text-muted">Monitor your profit, expenses and inventory per department.</p>
          </div>
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/merp/6.png" data-fancybox="merp-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/merp/6.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
            <a href="/img/merp/6.png" data-fancybox="merp-images">
              <h3 class="h5 mb-1">Purchase Orders</h3>
            </a>
            <p class="text-muted">Manage your purchase orders, approvals, receivings and re-orders.</p>
          </div>
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/merp/7.png" data-fancybox="merp-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/merp/7.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
            <a href="/img/merp/7.png" data-fancybox="merp-images">
              <h3 class="h5 mb-1">HR</h3>
            </a>
            <p class="text-muted">Mange your employees work schedules, leaves, cash advances and charges.</p>
          </div>
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/merp/8.png" data-fancybox="merp-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/merp/8.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
            <a href="/img/merp/8.png" data-fancybox="merp-images">
              <h3 class="h5 mb-1">Point of Sale</h3>
            </a>
            <p class="text-muted">Provides point of sale system per department/store.</p>
          </div>
        </div>
      </section>
    </div>
    <Footer/>
  </div>
</template>

<script>

import Footer from '@/components/Footer.vue'

export default {
  name: 'ActMonit',
  components: {
    Footer
  }
}
</script>

<style lang="scss">
  .banner-section {
    background:#f8f9fa url('/img/cityscape.png') no-repeat center bottom;
  }
  .merp-banner {
    overflow: hidden;
    height: 350px;
    text-align: center;
    box-shadow: -2px 2px 7px -1px rgba(0,0,0,0.2);
  }
</style>